//  NOTE: This file is used as a source file for:
//     api/models/listingcollections.go
// This is so that bulk editing stays in sync between the frontend and backend.
// Therefore, any change at all in this file means you MUST run the following
// script which will update the file in go.
//     make update_bulk_edit
//
export default {
	advancedcare: {
		label: "Complex care",
		options: {
			"auslan-sign-language": "Auslan (sign language)",
			"challenging-behaviours": "Challenging behaviours",
			"general-mental-health": "General mental health",
			"jejunostomy-feeding": "Jejunostomy feeding",
			"motor-neurone-disease": "Motor neurone disease",
			"multiple-sclerosis-ms": "Multiple sclerosis (MS)",
			"nasogastric-feeding": "Nasogastric feeding",
			"peg-feeds": "Peg feeds",
			"peri-dialysis": "Peri dialysis",
			"physiotherapy-on-site": "Physiotherapy (on-site)",
			"power-wheelchair": "Power wheelchair",
			"spinal-care": "Spinal care",
			tracheotomy: "Tracheotomy"
		}
	},
	specialisedcare: {
		label: "Specialised care",
		options: {
			"dementia-support": "Dementia support",
			"dementia-high-care-(integrated)": "Dementia high care (integrated)",
			"secure-dementia-care": "Secure dementia care",
			"bariatric-care": "Bariatric care",
			"post-operative-care": "Post-operative care",
			"transition-care": "Transition care",
			"facility-is-dementia-specific":
				"Facility is dementia specific (All residents have a form of dementia)"
		}
	},
	therapycare: {
		label: "Health and therapy services",
		options: {
			dental: "Dental",
			"general-practitioners": "General practitioners",
			massage: "Massage",
			"nurse-on-call": "Nurse on call",
			optometry: "Optometry",
			physiotherapy: "Physiotherapy",
			podiatry: "Podiatry",
			psychiatry: "Psychiatry",
			psychology: "Psychology",
			reflexology: "Reflexology",
			"speech-pathology": "Speech pathology"
		}
	},
	mentalhealth: {
		label: "Dedicated services",
		options: {
			"geriatric-psychiatry-unit": "Geriatric psychiatry unit",
			"palliative-care-unit": "Palliative care unit"
		}
	},
	shortstaycare: {
		label: "Short stay",
		options: {
			"day-program": "Day program",
			"dedicated-respite-rooms": "Dedicated respite room(s)",
			"emergency-respite": "Emergency respite",
			"non-acat-respite-accepted": "Non-ACAT respite accepted",
			"non-weight-bearing": "Non-weight bearing",
			"planned-respite": "Planned respite",
			"respite-in-secure-dementia-care": "Respite in secure dementia care"
		}
	},
	covid19: {
		label: "COVID-19",
		options: {
			"covid-19-vaccine": "COVID-19 vaccine"
			// "no-visits": "No visits",
			// "compassionate-palliative-visits": "Compassionate / palliative visits",
			// "window-visits": "Window visits",
			// "video-phone-visits": "Video / phone visits",
			// "visits-limited-to-specific-areas": "Visits limited to specific areas",
			// "case-by-case-tours-following-gov-advice":
			// 	"Case-by-case tours, following Gov. advice",
			// "video-tours-only": "Video tours only",
			// "offsite-meetings-available": "Offsite meetings available",
			// "tours-req-screening-restrictions": "Tours req. screening & restrictions",
			// "isolation-mandatory-on-admission": "Isolation mandatory on admission",
			// "no-isolation-with-negative-covid-19-test":
			// 	"No isolation with negative COVID-19 test",
			// "can-manage-residents-who-cant-be-isolated":
			// 	"Can manage residents who can’t be isolated",
			// "mandatory-covid-19-test-on-admission":
			// 	"Mandatory COVID-19 test on admission",
			// "isolation-until-covid-19-test-result":
			// 	"Isolation until COVID-19 test result",
			// "accepting-covid-19-recovery-negative-test-permanent-admissions":
			// 	"Accepting COVID-19 recovery (negative test) permanent admissions",
			// "accepting-covid-19-recovery-negative-test-respite-admissions":
			// 	"Accepting COVID-19 recovery (negative test) respite admissions"
		}
	}
};
